import * as React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  SimpleForm,
  BooleanField,
  NumberField,
  TextField,
  BooleanInput,
  NumberInput,
  TextInput,
  ShowButton,
  Pagination,
} from 'react-admin'

export const CityList = props => (
  <List
    {...props}
    title="Cities List"
    perPage={100}
    sort={{ field: 'name', order: 'ASC' }}
    pagination={<Pagination rowsPerPageOptions={[]} />}
  >
    <Datagrid>
      <TextField source="name" />
      <NumberField source="index" />
      <BooleanField source="disabled" />
      <ShowButton label="" />
    </Datagrid>
  </List>
)

export const CityEdit = props => (
  <Edit {...props} title="Cities Edit" undoable={false}>
    <SimpleForm>
      <TextInput source="name" options={{ fullWidth: true }} />
      <NumberInput source="index" />
      <BooleanInput source="disabled" />
    </SimpleForm>
  </Edit>
)

export const CityCreate = props => (
  <Create {...props} title="Cities Create">
    <SimpleForm>
      <TextInput source="name" options={{ fullWidth: true }} />
      <NumberInput source="index" />
      <BooleanInput source="disabled" />
    </SimpleForm>
  </Create>
)
